module.exports = __webpack_public_path__ + "img/keyboard_arrow_left-24px.5cea32b1.svg";